
const ValidateScoreValue = (value) => {

  if (parseFloat(value) < 1 ) {
    return 'Input must be positive integer and at least 1';
  }

  if (parseFloat(value) > 10 ) {
    return 'Score maximum value is 10 ';
  }

  return null;
};

export default ValidateScoreValue;



// WEBPACK FOOTER //
// ./src/components/validation/rules/scoreValue.js